import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme, { combineValues } from '@cld/theme-helper';
import { asStyledComponent } from '@cld/component-enhancer';
import './CustomerLogo.theme';

export const Logo = styled.img`
  min-height: ${theme`components.customer-logo.sm`};
  max-height: ${combineValues(theme`components.customer-logo.${'size'}`, '100%', (themeSize, defaultSize) => themeSize || defaultSize)};
  max-width: ${combineValues(theme`components.customer-logo.${'size'}`, '100%', (themeSize, defaultSize) => themeSize || defaultSize)};
  background-color: ${theme`color.white`};
`;

const CustomerLogo = ({ fallback, onError, ...props }) => {
  const handleError = useCallback(
    (e) => {
      e.target.onerror = null;
      e.target.src = fallback;
      if (onError) {
        e.persist();
        onError(e);
      }
    },
    [onError, fallback]
  );
  return <Logo alt="logo" onError={fallback ? handleError : onError} {...props} />;
};

CustomerLogo.propTypes = {
  fallback: PropTypes.string,
  size: PropTypes.string,
  src: PropTypes.string.isRequired,
  onError: PropTypes.func,
};

export default asStyledComponent(CustomerLogo);
